import gql from 'graphql-tag';
import { ApolloClient } from '@apollo/client';

export const gqlUserLogin = gql`
  query userLogin($userName: String, $userPassword: String) {
    userLogin(userName: $userName, userPassword: $userPassword) {
      jwt
      userMustChangePassword
      expirationDate
      userId
      userFirstName
      userLastName
    }
  }
`;

export const gqlUserMailTempPassword = gql`
  mutation userMailTempPassword($email: String!) {
    userMailTempPassword(email: $email)
  }
`;

const UserLoginDocument = gql`
  query userLogin($userName: String, $userPassword: String) {
    userLogin(userName: $userName, userPassword: $userPassword) {
      jwt
      userMustChangePassword
      expirationDate
      userId
      userFirstName
      userLastName
      userView {
        id
        referenceId2
        referenceName
        referenceName2
      }
    }

    getUserUsrParamsValues(userName: $userName) {
      data {
        id
        paramName
        intValue
      }
      recordCount
    }
  }
`;

export function userLogin(
  client: ApolloClient<object>,
  userName: string,
  userPassword: string,
): Promise<any> {
  return new Promise((resolve, reject) => {
    client
      .query<any, any>({
        query: UserLoginDocument,
        variables: { userName, userPassword },
        fetchPolicy: 'network-only',
      })
      .then(
        (res) => {
          if (res && res?.data?.userLogin && res?.data?.userLogin !== null) {
            resolve({
              ...res?.data?.userLogin,
              getUserUsrParamsValues: res?.data?.getUserUsrParamsValues.data,
            });
          } else {
            if (res?.errors[0]?.message) reject(res?.errors[0]?.message);
            else reject('Λάθος στην επικοινωνία με το server');
          }
        },
        (reason) => console.log('userLogin query rejected', reason),
      )
      .catch((err) => reject(err));
  });
}
